import { ConsoleLogger } from '@microsoft/signalr/dist/esm/Utils';
import React, { useState, useEffect, Fragment } from 'react';
import {
    Card,
    CardBody,
    Button,
    ButtonGroup,
    Row,
    CustomInput,
    Modal,
    Input,
    ModalHeader,
    ModalBody,
    ModalFooter
} from 'reactstrap';

import { Colxx, Separator } from '../../../../../../components/common/CustomBootstrap';
import Tooltip from './../Tooltip';

let arr = [];
export default function SpaceSettings({
    integration,
    integrationProperties,
    allProperties,
    saveIntegration,
}) {
    const [bookingConfirmation, setBookingConfirmation] = useState(integration.bookingConfirmationSettings === undefined ?
        "ManualReview" : integration.bookingConfirmationSettings.bookingConfirmation);
    const [emailConfirmation, setEmailConfirmation] = useState(integration.bookingConfirmationSettings === undefined ?
        "Automated" : integration.bookingConfirmationSettings.emailConfirmation);
    const [isEditing, setIsEditing] = useState(false);
    const [list, setList] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [isAddons, setIsaddons] = useState(integration.bookingConfirmationSettings === undefined ? false :
        integration.bookingConfirmationSettings.addonsEnabled === undefined ? false : integration.bookingConfirmationSettings.addonsEnabled)
    let [contactsList, setContactsList] = useState(integration.bookingConfirmationSettings.contacts || [{
        name: '',
        email: '',
        phoneNumber: '',
        isBCC: false,
    }]);

    const AddContacts = () => {
        let lst = [...contactsList];
        lst.push({
            name: '',
            email: '',
            phoneNumber: '',
            isBCC: false,
        });
        setContactsList(lst);
    }

    const RemoveContacts = (val) => {
        console.log(val);
        let lst = [...contactsList];
        lst = contactsList.filter((f, index) => index !== val);
        setContactsList(lst);
    }

    const handleSave = () => {
        integration.bookingConfirmationSettings = {
            bookingConfirmation: bookingConfirmation,
            emailConfirmation: emailConfirmation,
            contacts: contactsList,
            addonsEnabled: isAddons
        }
        saveIntegration({ pageSettings: integration });
        arr = [];
        setList([]);
        setIsEditing(!isEditing);
    };

    const handleChange = (e, val, type) => {
        console.log(type);
        let lst = [...contactsList];
        if (type === 'Name')
            lst[val].name = e
        if (type === 'Email')
            lst[val].email = e
        if (type === 'Number')
            lst[val].phoneNumber = e
        if (type === 'BCC')
            lst[val].isBCC = e
        setContactsList(lst);
    };



    return <Card className="mb-4">
        <Fragment>
            <CardBody>
                <div className="text-center">
                    <div className="mb-3">
                        <h6> Booking Confirmation </h6>
                        <div className="mb-2">
                            <CustomInput
                                id="booking1"
                                type="radio"
                                label="Automated"
                                checked={bookingConfirmation === "Automated"}
                                onChange={event =>
                                    setBookingConfirmation(event.target.value === "on" ? "Automated" : "ManualReview")
                                }
                            />
                            <CustomInput
                                id="booking2"
                                type="radio"
                                label="ManualReview"
                                checked={bookingConfirmation === "ManualReview"}
                                onChange={event =>
                                    setBookingConfirmation(event.target.value === "on" ? "ManualReview" : "Automated")
                                }
                            />
                        </div>
                    </div>
                    <div>
                        <h6>Email Confirmation</h6>
                        <div className="mb-2">
                            <CustomInput
                                id="email1"
                                type="radio"
                                label="Automated"
                                checked={emailConfirmation === "Automated"}
                                onChange={event =>
                                    setEmailConfirmation(event.target.value === "on" ? "Automated" : "SentExternally")
                                }
                            />
                            <CustomInput
                                id="email2"
                                type="radio"
                                label="SentExternally"
                                checked={emailConfirmation === "SentExternally"}
                                onChange={event =>
                                    setEmailConfirmation(event.target.value === "on" ? "SentExternally" : "Automated")
                                }
                            />
                        </div>
                    </div>
                    <div className='mb-3'>
                        <Button
                            size="xs"
                            color="success"
                            outline
                            style={{ marginTop: '20px', display: 'inline-block' }}
                            onClick={() => setShowModal(!showModal)}
                        >
                            + Add Notifications
                        </Button>

                    </div>
                    <div>
                        <h6>Add-On's</h6>
                        <div className="mb-2">
                            <CustomInput
                                id="addons"
                                type="checkbox"
                                label="Enabled"
                                checked={isAddons}
                                onChange={event =>
                                    setIsaddons(event.target.checked)
                                }
                            />
                        </div>
                    </div>

                    <Button
                        size="xs"
                        color="primary"
                        outline
                        style={{ marginTop: '20px', display: 'inline-block' }}
                        onClick={() => handleSave()}
                    >
                        Save
                    </Button>
                </div>
            </CardBody>
            <Modal isOpen={showModal} toggle={() => setShowModal(!showModal)} size="lg">
                <ModalHeader>
                    Contacts
                </ModalHeader>
                <ModalBody toggle={() => setShowModal(!showModal)}>
                    {(contactsList !== undefined && contactsList.length > 0) ? contactsList.map((m, index) => {
                        return (<Fragment>
                            <Row>
                                <Colxx md={3}>
                                    <Input
                                        className='mt-2'
                                        style={{ borderRadius: '10px' }}
                                        type="text"
                                        value={m.name}
                                        placeholder="Name"
                                        onChange={(e) => handleChange(e.target.value, index, 'Name')}
                                    />
                                </Colxx>
                                <Colxx md={3}>
                                    <Input
                                        className='mt-2'
                                        style={{ borderRadius: '10px' }}
                                        type="text"
                                        value={m.email}
                                        placeholder="E-mail"
                                        onChange={(e) => handleChange(e.target.value, index, 'Email')}
                                    />
                                </Colxx>
                                <Colxx md={3}>
                                    <Input
                                        className='mt-2'
                                        style={{ borderRadius: '10px' }}
                                        type="text"
                                        value={m.phoneNumber}
                                        placeholder="Phone Number"
                                        onChange={(e) => handleChange(e.target.value, index, 'Number')}
                                    />
                                </Colxx>
                                <Colxx md={1}>
                                    <CustomInput
                                        id="checkbox"
                                        type="checkbox"
                                        className='mt-2'
                                        label="BCC"
                                        checked={m.isBCC === true}
                                        onChange={(e) => handleChange(e.target.checked, index, 'BCC')}
                                    />
                                </Colxx>
                                <Colxx md={2}>
                                    <Button color="danger" className='mt-2' size="xs" outline onClick={() => RemoveContacts(index)}>
                                        Remove
                                    </Button>
                                </Colxx>
                            </Row>
                        </Fragment>)
                    }
                    ) : null}

                    <Row className="my-2">
                        <Colxx md={12}>
                            <Button color="primary" size="xs" outline onClick={() => AddContacts()}>
                                Add Row
                            </Button>
                        </Colxx>
                    </Row>
                </ModalBody>

                <ModalFooter>
                    <Button color="primary" onClick={() => setShowModal(!showModal)}>
                        Close
                    </Button>{" "}
                </ModalFooter>
            </Modal>
        </Fragment>
    </Card >;
}
